// extracted by mini-css-extract-plugin
export default {"verticalLine":"style_verticalLine__KLI+V"};